function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "B9C55721-365F-43A2-A5F0-A9EB80D2AED8@1.00x");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Streetlight-Outage",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "A.1.3-Streetlight-Outage---View-Map",
  transform: "translate(-579.000000, -631.000000)",
  stroke: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(579.000000, 630.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "switch",
  transform: "translate(1.666667, 1.750000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.6666667,9.1875 C16.6666667,14.0199916 12.9357062,17.9375 8.33333333,17.9375 C5.74757523,17.781913 3.33666402,16.5161846 1.66666667,14.4375",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,9.1875 C0,4.35500844 3.73096042,0.4375 8.33333333,0.4375 C10.9190914,0.593087024 13.3300026,1.85881541 15,3.9375",
  id: "Path",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  strokeWidth: 1.5,
  points: "11.6666667 3.9375 15 3.9375 15 0.4375"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "5 14.4375 1.66666667 14.4375 1.66666667 17.9375"
})))));

var SvgIconSwitch = function SvgIconSwitch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSwitch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconSwitch.8486474f.svg";
export { ForwardRef as ReactComponent };